import type {
  SoundDesignAsset,
  SoundDesignSnippetAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { type TracksStore, TrackType } from '@/shared/store/tracks.store.tsx'

export const mapSoundDesignClipsToAssets = (
  tracksStore: TracksStore
): Record<string, SoundDesignAsset | SoundDesignSnippetAsset> => {
  const soundDesignTrack = tracksStore.tracks.find(
    ({ type }) => type === TrackType.SoundDesigns
  )

  const soundDesigns = soundDesignTrack?.clips ?? []

  const soundDesignClips = soundDesigns.filter(
    (clip): clip is typeof clip & { startAt: number } =>
      clip.startAt !== undefined
  )

  const soundDesignAssets: Record<
    string,
    SoundDesignAsset | SoundDesignSnippetAsset
  > = {}

  for (const sd of soundDesignClips) {
    // Create a unique key for the sound template to avoid conflicts
    const templateKey = `${sd.name}_sound_template`

    // Only create the sound template asset if it doesn't already exist
    soundDesignAssets[templateKey] ??= {
      type: 'soundTemplate',
      soundTemplateAlias: sd.name,
      segment: 'main',
      ...(sd.src && { uri: sd.src }),
    }

    // Always create the snippet asset, referencing the template
    soundDesignAssets[sd.id] = {
      type: 'soundTemplateSnippet',
      soundTemplateRef: templateKey,
      targetDuration: sd.duration + sd.endOffset,
      ...(soundDesignTrack?.smartFit ? { smartFit: true } : {}),
    }
  }

  return soundDesignAssets
}
